import { createContext } from 'react';
import createStateProvider from '../../../Shared/createStateProvider';
import { AirportType } from './SummaryProvider';

type StateType = {
  departureAirports: AirportType[];
  destinationAirports: AirportType[];
};

const StateContext = createContext<StateType>({} as StateType);

const toInitialState = (state, { isNewSearch } = { isNewSearch: false }) => ({
  ...state,
  isNewSearch,
});

const { StateProvider, useFilterState, useAvailableFilterState } =
  createStateProvider('airports', StateContext, toInitialState);

export const useLegFilterState = (legId, airportType) => {
  const { airports } = useFilterState();
  if (!airports) {
    return null;
  }
  return airports[legId][airportType];
};

export const useIsAbleToBeUnfiltered = () => {
  const availableAirports = useAvailableFilterState();
  const { isNewSearch } = useFilterState();
  return isNewSearch && (availableAirports?.isAbleToBeUnfiltered ?? false);
};

export default StateProvider;

export { useFilterState, useAvailableFilterState };
